export default __webpack_public_path__ + "static/media/header-right.8e298b0a.png";